import { isNil } from "@fxts/core"

import { CustomerModel } from "../models"
import { isEqualsBusinessRegistrationNumber } from "./isEqualsBusinessRegistrationNumber"
import { isEqualsTaxRegistrationId } from "./isEqualsTaxRegistrationId"

type CustomerEquality = Pick<
  CustomerModel,
  "businessRegistrationNumber" | "taxRegistrationId"
>
export const isEqualsCustomer = (a: CustomerEquality, b: CustomerEquality) => {
  if (isNil(a) || isNil(b)) {
    return false
  }

  const isSameBusinessNumber = isEqualsBusinessRegistrationNumber(
    a.businessRegistrationNumber,
    b.businessRegistrationNumber,
  )
  if (a.taxRegistrationId || b.taxRegistrationId) {
    const isSameTaxRegistrationId = isEqualsTaxRegistrationId(
      a.taxRegistrationId || "",
      b.taxRegistrationId || "",
    )
    return isSameBusinessNumber && isSameTaxRegistrationId
  }
  return isSameBusinessNumber
}
